import { resolveURL, withQuery } from "ufo";

export default defineNuxtPlugin( () => {
  const runtimeConfig = useRuntimeConfig();

  if ( runtimeConfig.public.scripts?.webForensics.url && runtimeConfig.public.scripts?.webForensics.key ) {
    const src = withQuery( resolveURL( runtimeConfig.public.scripts?.webForensics.url, "/v1" ), {
      key: runtimeConfig.public.scripts?.webForensics.key,
    } );

    useScript( {
      src,
      async: true,
    } );
  }
} );
